<template>
  <div class="form-polar">
    <h1 class="title">{{questionTitle}}</h1>
    <div class="polar-options">
      <div
        v-for="answer in answers"
        class="half-btn"
        :key="answer.description"
        @click="pickanswer(answer)">

        <rp-button
          :class="{'is-primary': selectedAnswer.value === answer.value}">
          {{answer.translation_entries[0].body}}
        </rp-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {required} from 'vuelidate/lib/validators'
  import RpButton from 'raypro_ui/src/components/ui/inputs/Button'
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'

  import {getQuestionnaireAnswer} from '@/api/questionnaire'

  export default {
    components: {
      RpButton,
      RpSprite
    },

    mounted() {
      this.checkQuestionStatus()
    },

    props: {
      question: Object,
      questionTitle: String
    },

    data() {
      return {selectedAnswer: false}
    },

    validations: {selectedAnswer: {required}},

    methods: {
      pickanswer(answer) {
        this.selectedAnswer = answer

        this.$emit('update', {name: this.selectedName, id: this.question.id, value: answer.value === 'true'})
      },

      checkQuestionStatus() {
        // Check if the question has been answered
        const questionId = this.question.id

        getQuestionnaireAnswer(questionId, this.patientId, this.questionnaireId)
          .then((response) => {
            const hasAnswer = response.data[0].answer.id

            if(hasAnswer) {
              this.$emit('answered', true)

              // Set answered answer
              const value = response.data[0].value
              const answer = response.data[0].answer.options.find((option) => {
                return option.value === 'true' ? 'yes' : 'no' === value
              })

              response.data[0].value = response.data[0].value === 'yes'

              this.selectedAnswer = answer
              this.$emit('currentQuestionAnswer', response.data[0])
            } else {
              this.$emit('answered', false)
            }
          })
          .catch(() => {
          })
      }
    },

    computed: {
      answers() {
        return this.question.answer.options
      },

      patientId() {
        return this.$route.params.id
      },
      questionnaireId() {
        return this.$route.params.questionnaireId
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .form-polar
    display: flex
    flex-flow: wrap
    text-align: left
    flex-direction: column
    padding-top: 30px

    .half-btn
      margin: auto

      @include media($media-small)
        width: 50%

      .btn
        padding: 30px 20px
        border: 2px solid black
        color: black
        font-size: 25px
        font-weight: bold
        line-height: 0
        margin: 0 auto 30px
        width: 100%

        @include media($media-small)
          width: 90%
          margin: 20px auto

        &.is-primary
          color: #fff
          border: 2px solid transparent

    .polar-options
      padding-top: 30px
      align-items: center

      @include media($media-medium)
        display: flex
        flex-flow: wrap
        justify-content: space-between

      .answer
        font-size: 2rem
        width: 100%
        // min-width: 4rem
        // height: 6rem

    .title
      font-size: 24px
</style>




// WEBPACK FOOTER //
// src/components/pages/Questionnaire/Elements/Boolean.vue